
import { useNavigate } from "react-router-dom";
import emailjs from 'emailjs-com'
import React, { useState } from 'react';

const initialState = {
  from_name: '',
  mobile: '',
  status: '',
  purpose:'',
  adress: '',
}
export const Contact = (props) => {
  const [{ from_name, purpose, mobile, status, adress }, setState] = useState(initialState)
  
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  const validateMobile = (mobile) => {
    const regex = /^\d{10}$/; // Regex for 10 digit mobile number
    return regex.test(mobile);
  };


  const clearState = () => setState({ ...initialState })


  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateMobile(mobile)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, e.target, process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          alert('Your Call Back Request has been submitted , you will get a get from our team within 5-10 min. Thanks for your patience')
          clearState();
          window.location.reload();
          navigate("/thanks");
        },
        (error) => {
          console.log(error.text)
        }
      )
  }
  return (
    <div>
      <title>24/7 Support for best ro repair service in india.</title>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-6'>
            <div className='row'>
              <div className='section-title'>
                <h2>SUBMIT A CALL BACK REQUEST</h2>
                <p style={{backgroundColor:'transparent'}}>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name='sentMessage' onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='name'
                        name='from_name'
                        className='form-control'
                        placeholder='Name*'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>


                      <select className="form-select form-control" id='purpose' name='purpose' aria-label="Purpose" onChange={handleChange} >
                        <option value="air-conditioner">Air conditioner</option>
                        <option value="water-purifier">Water Purifier</option>
                        <option value="refrigirator">Refrigerator</option>
                        <option value="washing-machine">Washing Machine</option>
                        <option value="ovens">Ovens</option>
                        <option selected value="other">Other</option>

                      </select>

                      <p className='help-block text-danger'></p>

                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='number'
                        id='mobile'
                        name='mobile'
                        className='form-control'
                        placeholder='Mobile Number* (10 digit)'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>

                    </div>
                  </div>
                  <div className='col-md-6'>
                  <div className='form-group'>
                  <select className="form-select form-control" id='status' name='status' aria-label="Status" onChange={handleChange}>
                    <option value="inwarranty">In Warranty / AMC </option>
                    <option selected value="outwarranty">Out of Warranty </option>
                  </select>
                  <p className='help-block text-danger'></p>

                </div>
                  </div>
                </div>


                <div className='form-group'>
                  <textarea
                    name='adress'
                    id='adress'
                    className='form-control'
                    rows=''
                    placeholder='Address'
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p>
                </div>
                <div id='success'></div>
                <button type='submit' className='btn btn-custom btn-lg' style={{ marginLeft: '20px' }}>
                  Get a Call Back From Us
                </button>
              </form>
            </div>
          </div>

          <div className='col-md-5 col-md-offset-1 contact-info'>
            <div className='contact-item'>
              <img src="img/ro-repair-contact.webp" className="img-responsive" alt="ro-repair-contact" />{" "}
            </div>
          </div>
          {/*
         <div className='col-md-3 col-md-offset-1 contact-info'>
            <div className='contact-item'>
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className='fa fa-map-marker'></i> Address
                </span>
                {props.data ? props.data.address : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-phone'></i> Phone
                </span>{' '}
                {props.data ? props.data.phone : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-envelope-o'></i> Email
                </span>{' '}
                {props.data ? props.data.email : 'loading'}
              </p>
            </div>
          </div> */}
          {/*
          <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : '/'}>
                      <i className='fa fa-facebook'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : '/'}>
                      <i className='fa fa-twitter'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : '/'}>
                      <i className='fa fa-youtube'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        */}
        </div>
      </div>

    </div>
  )
}
